import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from '../../../../core/Button/Button.jsx';
import {
    joinTournament,
    quitTournament,
} from '../../../../redux/actions/tournament/actions.js';
import { addWaitingProcess } from '../../../../redux/actions/cash/actions.js';

function PendingTournamentButton({ row, desktopRequire = false }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.user.id);
    const isMobile = useSelector((state) => state.user.isMobile);
    const waitingProcesses = useSelector((state) => state.cash.waitingProcesses);
    const list = useSelector((state) => state.tournament.list);

    // Fetch the tournament data
    const tournament = list[row.table_tournament_id] || {};
    const tournamentPlayers = tournament?.players || {};

    // If registration is disabled, return null
    if (!tournament?.info.registrationEnabled) return null;

    // Determine button state based on waiting process and player status
    const isWaiting = waitingProcesses.includes(row.table_tournament_id);
    const isPlayerPending = tournamentPlayers[userId]?.status === 'PENDING';
    const cls = tournament?.info?.bettingTimer > -1 && tournament?.info?.bettingTimer <= 0 ? 'disabled-element' : '';
    const isDisabled = tournament?.info?.bettingTimer > -1 && tournament?.info?.bettingTimer <= 0;

    let buttonProps = {
        type: 'green',
        text: t(`tournament.join`),
        icon: 'icon-user-plus',
        action: () => {
            if (isDisabled || isWaiting || isPlayerPending) return;
            dispatch(addWaitingProcess({ process: tournament.id }));
            dispatch(joinTournament({ tournamentId: tournament.id, amount: null }));
        },
    };

    if (isWaiting) {
        buttonProps = {
            type: 'blue-border',
            text: <i className='icon-spinner8 rotate' />,
            icon: 'icon-spinner8 rotate',
            action: () => {}, // No action while loading
        };
    } else if (isPlayerPending) {
        buttonProps = {
            type: 'red',
            text: t(`tournament.quit`),
            icon: 'icon-user-check',
            action: () => {
                if (isDisabled) return;
                dispatch(addWaitingProcess({ process: tournament.id }));
                dispatch(quitTournament({ tournamentId: tournament.id }))
            },
        };
    }

    const handleMobileClick = (e) => {
        e.stopPropagation();
        buttonProps.action();
    };

    const buttonElement = (
        <Button
            type={buttonProps.type}
            onClick={buttonProps.action}
            text={buttonProps.text}
            cls={cls}
            isDisabled={isDisabled}
        />
    );

    if (desktopRequire) {
        return <div className="button-size">{buttonElement}</div>;
    }

    return !desktopRequire && !isMobile ? (
        <div className="button-size">{buttonElement}</div>
    ) : (
        <i className={buttonProps.icon} onClick={handleMobileClick} />
    );
}

export default PendingTournamentButton;
